import { useMemo, useState } from "react";
import "./fleetViewAlert.css";

const ALERT_TYPES = [
  { key: "isOverweight", label: "Overload", priority: 1 },
  { key: "harshBrake", label: "Harsh Brake", priority: 2 },
  { key: "harshAccel", label: "Harsh Accel", priority: 2 },
  { key: "ptoActive", label: "PTO Active", priority: 3 },
  { key: "tailGateActive", label: "Tailgate Active", priority: 3 },
  { key: "tarpActive", label: "Tarp Active", priority: 3 },
  { key: "binActive", label: "Bin Active", priority: 3 },
  { key: "serviceDue", label: "Service Due", priority: 2 },
];

const FleetViewAlert = ({ fleetList, onFleetSelect }) => {
  const [isOpen, setIsOpen] = useState(false);

  // 🔴 CORE: group alerts
  const groupedAlerts = useMemo(() => {
    const map = {};

    for (const type of ALERT_TYPES) {
      map[type.key] = [];
    }

    for (const f of fleetList) {
      if (!f) continue;

      if (f.isOverweight) map.isOverweight.push(f);
      if (f.flags?.ptoActive) map.ptoActive.push(f);
      if (f.flags?.tarpActive) map.tarpActive.push(f);
      if (f.flags?.tailGateActive) map.tailGateActive.push(f);
      if (f.flags?.binActive) map.binActive.push(f);
      if (f.flags?.harshAccel) map.harshAccel.push(f);
      if (f.flags?.harshBrake) map.harshBrake.push(f);

      // service due (from details)
      if (f.nextServiceOn && new Date(f.nextServiceOn) < Date.now()) {
        map.serviceDue.push(f);
      }
    }

    return map;
  }, [fleetList]);

  // total count
  const totalAlerts = useMemo(() => {
    return Object.values(groupedAlerts).reduce(
      (sum, arr) => sum + arr.length,
      0,
    );
  }, [groupedAlerts]);

  // return of no alerts
  if (totalAlerts === 0) return null;

  return (
    <div className={`alert-widget ${isOpen ? "open" : ""}`}>
      {/* COLLAPSED */}
      <div className="alert-collapsed" onClick={() => setIsOpen(!isOpen)}>
        <span>⚠️</span>
        <span className="alert-badge">{totalAlerts}</span>
      </div>

      {/* EXPANDED */}
      {isOpen && (
        <div className="alert-panel">
          <div className="alert-header">
            <span>Alerts ({totalAlerts})</span>
            <button onClick={() => setIsOpen(false)}>×</button>
          </div>

          <div className="alert-list">
            {[...ALERT_TYPES]
              .sort((a, b) => a.priority - b.priority)
              .map((type) => {
                const list = groupedAlerts[type.key];
                if (!list || list.length === 0) return null;

                return (
                  <div key={type.key} className="alert-group">
                    <div className="alert-group-title">
                      {type.label} ({list.length})
                    </div>

                    {list.slice(0, 5).map((f) => (
                      <div
                        key={f.vehicleId}
                        className="alert-item"
                        onClick={() => {
                          onFleetSelect(f.vehicleId);
                          setIsOpen(false); // close panel after click
                        }}
                      >
                        {f.vehicleCode || f.vehicleId.slice(-4)}
                      </div>
                    ))}
                  </div>
                );
              })}
          </div>
        </div>
      )}
    </div>
  );
};

export default FleetViewAlert;
